// @ts-ignore
import image from "@assets/images/cropping-suitability/land-suitability-class.png";
import Title from "@/shared/components/report-template/presentation/components/common/Title";
import ReportTemplate from "@/shared/components/report-template/presentation/components/ReportTemplate";

const HelpLandSuitabilityClass = () => {
  return (
    <ReportTemplate serviceType="CROPPING_SUITABILITY" pageNumber={3}>
      <div className="w-full flex flex-col gap-6 mt-20">
        <div className="w-full flex justify-center items-center">
          <div className="w-full ">
            <img className="w-full h-full" src={image} alt="definition" />
          </div>
        </div>
        <div className="text-center mt-4">
          <Title>راهنمای کلاس‌های تناسب اراضی</Title>
        </div>
      </div>
    </ReportTemplate>
  );
};

export default HelpLandSuitabilityClass;
